// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"46106b0584c9d00f","5285":"0fb42f4b42a26739"}[chunkId] + ".css";
};